module.exports = __webpack_public_path__ + "static/media/solastalgia-sm-8.b36e9de5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solastalgia/solastalgia-sm-8.jpg
// module id = 4438
// module chunks = 13